import React from 'react';
import PropTypes from 'prop-types';

import { UnlinkFulfillmentPlanConfirmationModal } from '../../../../../../../fulfillment-plans/unlink-button/modal';
import { useEntitiesFulfillmentPlan } from '../../../../../../../hooks/entities/selectors/fulfillment-plans';
import { useFulfillmentPlanIdContext } from '../../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useSalesOrderIdContext } from '../../../../../../context/sales-order-id-context-provider';

export const RemoveShipmentModal = ({ onClose }) => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const salesOrderId = useSalesOrderIdContext();
  const { salesOrdersFulfilledIds } = useEntitiesFulfillmentPlan(fulfillmentPlanId) || {};

  return (
    <UnlinkFulfillmentPlanConfirmationModal
      fulfillmentPlanId={fulfillmentPlanId}
      onClose={onClose}
      salesOrderId={salesOrderId}
      salesOrdersFulfilledIds={salesOrdersFulfilledIds}
    />
  );
};

RemoveShipmentModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
